import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalsenttouser from './Modalsenttouser';
import Modalarticlefacultybnrobtwo from './Modalarticlefacultybnrobtwo';
//import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';


import Swal from 'sweetalert2'
import Modalsenttouserex from './Modalsenttouserex';
import Modalarticlefacultybnrobtwoex from './Modalarticlefacultybnrobtwoex';


export default class Commentexlistforadminfaculty extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentexforadmin:[],

   id_ex:'',
   ex_comment:'',
   id_bn:'',
   
}


this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
//  this.props.selectex();
}




 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
       this.setState({ id_send:this.props.id_send,
        ex_comment:this.props.ex_comment
         })
      setTimeout(() => {
       
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforadminfacultyex.php?id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
       
          this.setState({ commentexforadmin: res.data})
          if (res.data.length !== 0) {
            this.setState({ id_ex: res.data[0].id_ex})
          }
        }) 

      }, 0);

      setTimeout(() => {
       
        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforadminfaculty.php?id_send='+this.props.id_send)
       .then(res => {
         console.log(res);
      
        // this.setState({ commentbnforadmin: res.data})
         if (res.data.length !== 0) {
           this.setState({ id_bn: res.data[0].id_bn})
         }
       }) 

     }, 0);

  }


  list() {
      setTimeout(() => {
         Axios.get('https://conference.kpru.ac.th/PHPAPI/selectcommentforadminfacultyex.php?id_send='+this.props.id_send)
        .then(res => {
          console.log(res);
          this.setState({ commentexforadmin: res.data})
          if (res.data.length !== 0) {
            this.setState({ id_ex: res.data[0].id_ex})
          }
        }) 
      }, 0);
  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
     // datafrm.append("ex_comment", '1');

//อัพเดทสถานะ
  Axios.post("https://conference.kpru.ac.th/PHPAPI/updatestapat3.php",datafrm)
    .then(res => {
      console.log("response: ", res)

      if (res.data.status = 'success999') {
   
        Swal.fire({
         title: 'อัพเดทสถานะสำเร็จ',
         text: "Successfully updated .",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.list()
             window.location.reload(false);
           //  this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
 
  
   })

 
}, 1000);

  }



    render() {
      //  console.log(this.state.id_bn)

        return (
            <>
                  <Modalarticlefacultybnrobtwoex id_send={this.state.id_send} id_ex={this.state.id_ex} id_bn={this.state.id_bn} list={this.list} />
      <MDBTable bordered>
      <MDBTableHead color="blue-grey lighten-3" >
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์บทความที่ส่งตรวจ</th>
          <th>วันที่ส่งตรวจ</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะส่งกลับจากผู้ทรง</th>
          <th>แจ้งผู้ส่งบทความ</th>
          <th>ไฟล์ข้อเสนอแนะ(ปิดชื่อ)</th>
          <th>ผู้ส่งบทความ ปรับแก้กลับ</th>
          <th>สถานะ</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentexforadmin.map((commentexforadmin,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td><a href={`https://conference.kpru.ac.th/PHPAPI/closeacticleex/${commentexforadmin.fileword}`}  target="_blank"><p className="indigo-text"><MDBIcon far icon="file-word" /> บทความที่ส่งตรวจ</p> </a>
                        <a href={`https://conference.kpru.ac.th/PHPAPI/closeacticleex/${commentexforadmin.filepdf}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> บทความที่ส่งตรวจ</p> </a>
                        </td>
                        <td>{commentexforadmin.date_sentex}</td>

                        <td>{commentexforadmin.filepdfcomment_ex !== null ? <>
                        <a  href={`https://conference.kpru.ac.th/PHPAPI/commentex/${commentexforadmin.filepdfcomment_ex}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" />แบบประเมินบทความ</p> </a>
                        <a  href={`hhttps://conference.kpru.ac.th/PHPAPI/commentex/${commentexforadmin.	filecomment_ex}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> ข้อเสนอแนะบทความ</p> </a>
                        </>:<><MDBIcon far icon="hourglass" /><p className="orange-text">อยู่ระหว่างผู้ทรงดำเนินการ</p></>}</td>
                       
                        <td>{commentexforadmin.date_senbacktex !== null ?<>{commentexforadmin.date_senbacktex}</>:<><MDBIcon far icon="hourglass" /></>}</td>
                        <td>{commentexforadmin.filepdfcomment_ex !== null ?<>
                        ส่งกลับแล้ว
                        </>:<>
                        <p className="orange-text">อยู่ระหว่างดำเนินการ</p>
                        </>}
                        </td>
                        <td>
                            {commentexforadmin.status_show === '1' ? <><MDBIcon icon="volume-up" /> แจ้งแล้ว</>:<>
                              {commentexforadmin.filepdfcomment_ex !== null?<>
                               <Modalsenttouserex id_send={commentexforadmin.id_send} id_excomment={commentexforadmin.id_excomment} id_ex={commentexforadmin.id_ex} list={this.list}  />
                              </>:<>
                              <p className="orange-text">อยู่ระหว่างดำเนินการ</p>
                              </>}
                           
                            </>}
                          
                        </td>

                        <td>{commentexforadmin.filepdfcomment_exclose !== null ? <><a  href={`https://conference.kpru.ac.th/PHPAPI/commentex/${commentexforadmin.filepdfcomment_exclose}`}  target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ</p> </a></>:<><MDBIcon far icon="hourglass" /><p>รอปิดชื่อ</p></>}</td>

                        <td>{commentexforadmin.sentbackeditword !== null ?<>
                            <MDBBtn color="indigo" size="sm" href={`https://conference.kpru.ac.th/PHPAPI/usereditbackex/${commentexforadmin.sentbackeditword}`}  target="_blank"><MDBIcon icon="arrow-alt-circle-down" /> WORD</MDBBtn>
                        {/* {commentbnforadmin.sentbackeditword} */}
                        </>:<> <p className="orange-text">อยู่ระหว่างดำเนินการ</p> </>}</td>
                        <td>{commentexforadmin.statuscomment_ex ==='1' ?<><p className="teal-text">ผ่าน</p></>:<>
                        {commentexforadmin.statuscomment_ex ==='0' ?<><p className="red-text">ไม่ผ่าน</p></>:<><p className="orange-text">อยู่ระหว่างดำเนินการ</p> </>}
                        </>}</td>
                        </tr>
                      )}
      </MDBTableBody>
    </MDBTable>
    {this.state.ex_comment === '1'?<><h4 className='text-center'>ผ่านขั้นตอนผู้ทรงคุณวุฒิแล้ว</h4></>:<> <div className='text-center'> <MDBBtn color="success" onClick={this.handleSubmit}>ผ่านขั้นตอนผู้ทรงคุณวุฒิ</MDBBtn> </div></>}
   
   
    

          </>
          
        )
    }
}


